import React from 'react';
import './Preloader.css';

const Preloader = () => {
  const fullText = "À chaque pas, la lumière de la Parole de Dieu.";

  return (
    <div className="preloader-container bg-lamp-dark">
      <div className="typing-wrapper">
        <h1 className="preloader-typing-text">
          {fullText}
        </h1>
      </div>
    </div>
  );
};

export default Preloader;
